import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const AdjustPageHeightControl = (function($) {

	var previousTimeout;

    TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onWindowResize, function() {
		adjustWithTimeout();
    });

    TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSearch, function() {
		adjustWithTimeout();
    });

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onHome, function() {
		adjustWithTimeout();
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onMyAccount, function() {
		adjustWithTimeout();
	});

    TLCEventManager.addListener(TLC_CONSTANTS.Events.onPagingModelResponse, function() {
        adjustMinHeight();
    });

	var adjustWithTimeout = function() {
		clearTimeout(previousTimeout);
		previousTimeout = setTimeout(function(){
			adjustMinHeight();
		}, 100);
	};

    var adjustMinHeight = function() {
		try {
			var totalHeight = $(window).height(),
				topNavHeight = $("#mainPage").find(".mainNav").get(0).offsetHeight,
				headerHeight = $("#" + LS2PAC_CONSTANTS.Ids.Header.mainHeader).get(0).offsetHeight,
				footer = $("#" + LS2PAC_CONSTANTS.Ids.Footer.mainFooter),
				footerHeight = footer.get(0).offsetHeight,
				$activeView = $("#" + LS2PAC_CONSTANTS.Ids.mainContent).find(".activeView"),
				//this is for the -55px the content overlaps in the header and footer
				contentOffset = (parseInt($activeView.css("marginTop"), 10) + parseInt(footer.css("marginTop"), 10)) * -1,
				offset =  21,
				minHeight = (totalHeight - (topNavHeight + headerHeight + footerHeight)) + (contentOffset - offset);

			if($activeView.length == 0 || $activeView.is(":visible") == false) {
				$activeView = $("#" + LS2PAC_CONSTANTS.Ids.mainContent);
				minHeight += offset;
			}

			//footerHeight += (global.isIE8) ? ((parseInt(footer.find("nav").css("paddingBottom"), 10) + parseInt(footer.find("nav").css("paddingtopNavHeight"), 10))) : 0;
			//minHeight = totalHeight - (((topNavHeight + headerHeight + footerHeight) - parseInt($("#" + LS2PAC_CONSTANTS.Ids.mainContent).css("paddingBottom"), 10)) - 130);

			//TLCLogger.log("contentOffset", contentOffset, "footermargin", (parseInt(footer.css("margintopNavHeight"), 10) * -1),"nav", topNavHeight, "footer", footer.get(0).offsetHeight, "footerHeight", footerHeight, "headerHeight", headerHeight, "totalHeight", totalHeight, "minHeight", minHeight);

			if($activeView.height() < minHeight) {
				$activeView.css("min-height", minHeight + "px");
				$("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchResultsAreaContainer).css("min-height", minHeight + "px");
			}
		} catch(e) {
			TLCLogger.log("adjustPageHeightControl.js: there was an error calculating the page heights to adjust the footer.  ", e);
		}
    };

    return {
        adjustMinHeight: adjustMinHeight
    };

})(jQuery);